module.exports = __webpack_public_path__ + "img/excosup-logo.0ad32548.png";